import { Badge } from '@gettactic/components/src/data-display/Badge/Badge';
import { TextInput } from '@gettactic/components/src/form/TextInput';
import { Draggable } from '@hello-pangea/dnd';
import React from 'react';
import { SpotLabelPatternItem } from '../../../types';

export interface NumberingToolSortableItemProps {
  pattern: SpotLabelPatternItem;
  index: number;
  updatePattern: (id: string, updates: Partial<SpotLabelPatternItem>) => void;
  removePattern: (id: string) => void;
}

export const NumberingToolSortableItem: React.FC<
  NumberingToolSortableItemProps
> = ({ pattern, index, updatePattern, removePattern }) => {
  return (
    <Draggable draggableId={index.toString()} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`flex items-start gap-4 p-4 bg-white rounded-lg border ${
            snapshot.isDragging
              ? 'shadow-lg border-blue-200 bg-blue-50 z-modal'
              : ''
          }`}
        >
          {/* TEMPORALLY REMOVED FOR sc-4283 */}
          {/*<div
            {...provided.dragHandleProps}
            className="mt-2 cursor-grab active:cursor-grabbing hover:text-blue-600"
          >
            <GripVertical className="w-4 h-4" />
          </div>*/}
          <Badge variant="outline" className="mt-2">
            {/* TEMPORALLY, REMOVE AFTER REINTRODUCTION OF FULL PATTERN FEATURE */}
            {pattern.type === 'text' && 'Prefix'}
            {/* TEMPORALLY, REMOVE AFTER REINTRODUCTION OF FULL PATTERN FEATURE */}
            {pattern.type === 'numbers' && 'Numbers'}
            {/* TEMPORALLY REMOVED FOR sc-4283 */}
            {/*{capitalize(pattern.type)}*/}
          </Badge>
          <div className="flex-1 space-y-4">
            {pattern.type === 'text' && (
              <TextInput
                placeholder="Value"
                value={pattern.value || ''}
                onChange={(e) =>
                  updatePattern(String(index), { value: e.target.value })
                }
              />
            )}
            {pattern.type === 'array' && (
              <TextInput
                placeholder="Values (comma-separated)"
                value={pattern.value?.join(', ') || ''}
                onChange={(e) =>
                  updatePattern(String(index), {
                    value: e.target.value.split(',').map((v) => v.trim())
                  })
                }
              />
            )}
            {(pattern.type === 'numbers' || pattern.type === 'letters') && (
              <TextInput
                type="number"
                placeholder="Depth"
                value={pattern.depth || '0'}
                onChange={(e) =>
                  updatePattern(String(index), {
                    depth: Number.parseInt(e.target.value) || 1
                  })
                }
              />
            )}
          </div>
          {/* TEMPORALLY REMOVED FOR sc-4283 */}
          {/*<Button
            variant="transparent"
            className="text-red-500 hover:text-red-600 hover:bg-red-50"
            onClick={() => removePattern(index)}
          >
            <Trash2 className="w-4 h-4" />
          </Button>*/}
        </div>
      )}
    </Draggable>
  );
};
